let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("168y5")).then(() => parcelRequire('xh7on'));